import { openReceiveAPI } from '@/utils/api';
import { normalizePlatformCode } from '@/utils/platformShopCatalog';
import {
  listEnabledListingAutoRules,
  normalizeListingAutoRuleList,
} from '@/pages/ipe/workbench/utils/listingAutoRule';

function normalizePickedRuleIds(picked) {
  if (!picked || picked.skip) return [];
  const fromList = Array.isArray(picked.listingAutoRuleIds)
    ? picked.listingAutoRuleIds
    : [];
  const ids = fromList
    .map((id) => Number(id))
    .filter((id) => Number.isFinite(id) && id > 0);
  if (ids.length > 0) return [...new Set(ids)];
  const single = Number(picked.listingAutoRuleId);
  return Number.isFinite(single) && single > 0 ? [single] : [];
}

function isBoundListingAutoRule(rule) {
  return rule?.shopId != null && String(rule.shopId).trim() !== '';
}

/**
 * 带入本地商品库前解析自动规则：
 * - 始终弹窗选择；无启用/可用规则时仍展示「仅带入」
 * - 「仅带入」与规则互斥；取消则中止
 *
 * @returns {Promise<{
 *   proceed: boolean,
 *   listingAutoRuleId: number|null,
 *   listingAutoRuleIds: number[],
 *   bindListingAutoRule: boolean,
 * }>}
 */
export async function resolveListingAutoRuleForIngest({ pickModal } = {}) {
  let rules = [];
  try {
    const payload = await openReceiveAPI.listAutoRules();
    rules = listEnabledListingAutoRules(normalizeListingAutoRuleList(payload))
      .filter(isBoundListingAutoRule);
  } catch (error) {
    console.warn('[listingAutoRulePick] 加载自动规则失败，仍打开选择弹窗', error);
    rules = [];
  }

  if (typeof pickModal !== 'function') {
    return {
      proceed: true,
      listingAutoRuleId: null,
      listingAutoRuleIds: [],
      bindListingAutoRule: false,
      hasTemuRule: false,
    };
  }

  const picked = await pickModal(rules);
  if (!picked) {
    return {
      proceed: false,
      listingAutoRuleId: null,
      listingAutoRuleIds: [],
      bindListingAutoRule: false,
      hasTemuRule: false,
    };
  }

  if (picked.skip) {
    return {
      proceed: true,
      listingAutoRuleId: null,
      listingAutoRuleIds: [],
      // 「仅带入」不绑定规则，否则 promote 会因 listingAutoRuleId 为空失败
      bindListingAutoRule: false,
      hasTemuRule: false,
    };
  }

  const listingAutoRuleIds = normalizePickedRuleIds(picked);
  const pickedRules = Array.isArray(picked.rules) ? picked.rules : [];
  // TEMU 规则需浏览器预组转图，后端流水线会延后，必须由前端补偿创建刊登任务
  const hasTemuRule = pickedRules.some(
    (rule) => normalizePlatformCode(rule?.platformCode) === 'TEMU',
  );
  return {
    proceed: true,
    listingAutoRuleId: listingAutoRuleIds[0] ?? null,
    listingAutoRuleIds,
    bindListingAutoRule: listingAutoRuleIds.length > 0,
    hasTemuRule,
  };
}
